import logo from "./logo.svg";
import "./App.css";
import SignUp from "./pages/SIgnUp/SignUp";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Kyc from "./pages/Kyc/Kyc";
import LoadMoney from "./pages/LoadMoney/LoadMoney";
import Payment from "./pages/Payment/Payment";
import CartLoadCard from "./pages/cardSample/CardSample";
import CartPage from "./pages/Cart/Cart";
import TestLink from "./pages/Test/TestLink";
import PaymentApps from "./pages/upiApps/upiApps";
import KycStatus from "./pages/KycStatus/KycStatus";
import CartSample from "./pages/CartSample/CartSample";

// const META = {
//   "/transaction": {
//     title: "Digital Escrow",
//     description: "Welcome to the home page",
//   },
// };

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/cart-sample" replace />} />
      <Route /* element={<Layout />} */>
        <Route path="/cart-sample" element={<CartSample />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/kyc" element={<Kyc />} />
        <Route path="/kyc-status" element={<KycStatus />} />
        <Route path="/load-money" element={<LoadMoney />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/cart" element={<CartPage />} />
        {/* <Route path="/generate-payment-link" element={<TestLink />} /> */}
        <Route path="/payment-apps" element={<PaymentApps />} />
      </Route>
    </Routes>
  );
}

export default App;
